export const CARD_HEIGHT = 175;
